<script setup lang="ts">
import { useI18n } from "vue-i18n";
import {
  REPORT_ENGINE_DEFAULT_TAB,
  reportEngineTabs,
} from "@/config/reportEngine/reportEngineTabs";

const { t } = useI18n({ useScope: "global" });

definePage({
  meta: {
    navActiveLink: "report-engine",
    key: "tab",
  },
});
</script>

<template>
  <div class="report-engine-page">
    <!--
      `reportEngineTabs` is passed straight through: its `{ tab, titleKey, icon,
      loader }` shape already satisfies `TabItem`, so the component map, the valid-tab
      set, the translated `tabs` computed and the writable route computed all moved
      into AppTabs/useTabs.
    -->
    <AppTabs
      :items="reportEngineTabs"
      variant="underline"
      sync-mode="param"
      sync-key="tab"
      :default-tab="REPORT_ENGINE_DEFAULT_TAB"
      card
      tabs-class="px-4"
      window-class="report-engine-page__content"
    >
      <template #header>
        <VCardText class="pa-6 pb-0">
          <h1 class="report-engine-page__title">
            {{ t("alkokh.reportEngine.title") }}
          </h1>
          <p class="report-engine-page__subtitle">
            {{ t("alkokh.reportEngine.subtitle") }}
          </p>
        </VCardText>
      </template>
    </AppTabs>
  </div>
</template>

<style scoped>
.report-engine-page {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.report-engine-page__title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
}

.report-engine-page__subtitle {
  color: rgba(var(--v-theme-on-surface), 0.68);
  margin: 4px 0 0;
}
</style>
